import React, { useState } from "react";
import {insertRole} from "./Services/insertRole"
import {useEffect} from "react";
import { fetchRole,fetchRole1 } from "./Services/fetchRole";
import { updateRole } from "./Services/updateRole";
import { deleteRoleById } from "./Services/DeleteRoleById";
import "./CSS/Module.css";

const CreateRoles = () => {
 
     useEffect(() => {
      const scriptUrls = [
        'assets/js/jquery.min.js',
        'assets/js/bootstrap.bundle.min.js',
        'assets/js/moment.min.js',
        'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
        'assets/vendor/overlay-scroll/custom-scrollbar.js',
        'assets/vendor/daterange/daterange.js',
        'assets/vendor/daterange/custom-daterange.js',
        'assets/vendor/datatables/dataTables.min.js',
        'assets/vendor/datatables/dataTables.bootstrap.min.js',
        'assets/vendor/datatables/custom/custom-datatables.js',
        'assets/js/custom.js'
      ];
  
      let isCancelled = false;
  
      // Load scripts sequentially
      const loadScriptsSequentially = async () => {
        for (const url of scriptUrls) {
          if (isCancelled) break;
  
          await new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = url;
            script.onload = resolve;
            script.onerror = reject;
            document.body.appendChild(script);
          });
        }
      };
  
      loadScriptsSequentially();
  
      return () => {
        isCancelled = true;
        // Optionally remove scripts if needed
      };
      }, []);
     
     
    function handleCancelMenu(e){
        e.preventDefault();
        let divPanel=document.getElementById('divPanel')
        divPanel.style.display="none";
        let divButtons= document.getElementById('cancel')
        divButtons.style.display="none";
       
        let addButtons =document.getElementById('add')
        addButtons.style.display="block";  
    }

    function addMenuPanel(e){
        e.preventDefault();
        let divPanel=document.getElementById('divPanel')
        divPanel.style.display="block";
        
        let divButtons= document.getElementById('cancel')
        divButtons.style.display="block";
        let addButtons =document.getElementById('add');
        addButtons.style.display="none";
        
       
    }
    
   const [roleName, setRoleName] = useState("");
   const [roleDiscription, setRoleDiscription] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    await insertRole({
      roleName,
      roleDiscription
    });

    setRoleName("");
    setRoleDiscription("");
    getRoles();
  };
  const [roles, setRoles] = useState([]);
  const [role1,setRole1] =useState('');
  const [ids, setIds] = useState(null);
  const getRoles =()=> {
    const fetch = async () => {
      const data = await fetchRole();
      setRoles(data);
    };
    fetch();
  }
  useEffect(()=>{

    getRoles();
  }, []);
  useEffect(() => {
    const getRole = async () => {
      const data = await fetchRole1(ids);
      setRole1(data);
    };

    getRole();
  }, [ids]);
  const [editRoleName, setEditRoleName] = useState("");
  const [editRoleDiscription, setEditRoleDiscription] = useState("");
  useEffect(() => {
    const selected = role1
    if (selected) {
      setEditRoleName(selected.roleName);
      setEditRoleDiscription(selected.roleDiscription);
    }
  }, [ids,role1]);

  const handleEdit = async () => {
    if (!editRoleName || !editRoleDiscription) {
      alert("Please fill in all required fields.");
      return;
    }

    try {
      await updateRole(ids, {
        roleName: editRoleName,
        roleDiscription: editRoleDiscription
      });
      getRoles(); // refresh table data
    } catch (err) {
      alert("Failed to update role");
    }
  };
  const [delId,setDelId]=useState(null);
  const handleDelete = async (id) => {
    await deleteRoleById(id);
    getRoles();
  };
  
  return(   
<div>
  {/* App hero header starts */}
  <div className="app-hero-header d-flex align-items-center">
    {/* Breadcrumb starts */}
    <ol className="breadcrumb">
      <li className="breadcrumb-item">
        <a href="#!">
          <i className="ri-home-3-line" />
        </a>
      </li>
      <li className="breadcrumb-item text-primary" aria-current="page">
        Create Roles
      </li>
    </ol>
    {/* Breadcrumb ends */}
    {/* Sales stats starts */}
    {/* <div className="ms-auto d-lg-flex d-none flex-row">
      <div className="input-group">
        <span className="input-group-text bg-primary-lighten">
          <i className="ri-calendar-2-line text-primary" />
        </span>
        <input type="text" id="abc" className="form-control custom-daterange" />
      </div>
    </div> */}
    {/* Sales stats ends */}
  </div>
  {/* App Hero header ends */}
  {/* App body starts */}
  <div className="app-body">
    {/* Row starts */}
    <div className="row gx-4">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            {/* Custom tabs starts */}
            <div className="custom-tabs-container">
              {/* Nav tabs starts */}
            
              {/* Nav tabs ends */}
              {/* Tab content starts */}
              <div className="tab-content h-350" style={{paddingTop:"0.5rem;"}}>
                
                <div className="tab-pane fade show active" id="twoA" role="tabpanel">
                  {/* Row starts */}
                  <div className="row justify-content-left">
                    <div className="col-sm-12 col-12" id="divPanel" style={{display:"none"}}>
                      <div className="card border mb-3">
                        <div className="card-body">
                        <div className="row gx-4">
                      <div className=" col-sm-5 col-12">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="newMod">New Roles <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <input type="text" id="newMod" className="form-control" placeholder="Create Roles." 
                              value={roleName}
                              onChange={(e) => setRoleName(e.target.value)}/>
                              <button className="btn btn-outline-secondary" type="button">
                                <i className="ri-menu-line text-black" />
                              </button>
                            </div> 
                          </div>
                       </div>
                       <div className=" col-sm-5 col-12">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="newDescriptionription"> Description <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <textarea row="2" type="text" id="newDescriptionription" className="form-control" placeholder="Enter description." 
                              value={roleDiscription}
                              onChange={(e) => setRoleDiscription(e.target.value)}/>
                              <button className="btn btn-outline-secondary" type="button">
                                <i className="ri-menu-line text-black" />
                              </button>
                            </div> 
                          </div>
                       </div>
                       <div className="col-sm-2 col-12">
                            <div className="mb-3 justify-content-right" style={{float:"right"}}>
                            <label className="form-label" htmlFor="newPwd">&nbsp;</label>
                            <div className="input-group">
                              <button type="submit" className="btn btn-primary add-element" onClick={handleSubmit} >
                                Add
                              </button>
                            </div>
                            </div>
                          </div>
                         
                          </div>
                         
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Row ends */}
                  <div className="card border">
                  <div className="row">
                    <div className="col-sm-6">
                  <div className="card-header">
                        <h5 className="card-title">Roles</h5>
                    </div>
                    </div>
                    <div className="col-sm-6">
                  <div id="addButtons"  className="d-flex justify-content-end" style={{paddingTop:"11px",width:"100%",paddingRight:"15px"}}>
                    <button type="button" id="cancel" className="btn btn-secondary " style={{display:"none"}} onClick={handleCancelMenu}>
                Cancel
              </button>
                    <button type="button" id="add" className="btn btn-primary"  onClick={addMenuPanel}>
                Add
              </button>
                    </div>
                    </div>
                    </div>
                  <div className="card-body pt-15">
  {/* Table starts */}
  {roles.length > 0 && (
  <div className="table-responsive">
    <table id="scrollVertical" className="table truncate m-0 align-middle">
      <thead>
        <tr>
          <th>ID</th>
          <th>Roles</th>
         
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      
      <tbody>
      {roles.map((mod, index) => (
              <tr key={mod.rolesId}>
                <td>#{index + 1}</td>
                <td>{mod.roleName}</td>
                <td>{mod.roleDiscription}</td>
                <td>
                  <div className="d-inline-flex gap-1">
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      data-bs-toggle="modal"
                      data-bs-target="#delRow"
                      onClick={() => setDelId(mod.rolesId)}
                    >
                      <i className="ri-delete-bin-line" />
                    </button>
                    <button
                      className="btn btn-outline-success btn-sm"
                      data-bs-toggle="modal"
                      data-bs-target="#editRoles"
                      data-bs-title="Edit Roles"
                      type="button"
                      onClick={() => setIds(mod.rolesId)}
                    >
                      <i className="ri-edit-box-line"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {roles.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center">
                  No Roles found.
                </td>
              </tr>
            )}
          </tbody>
    </table>
  </div>)}
  {/* Table ends */}
  {/* Modal Delete Row */}
  <div className="modal fade" id="delRow" tabIndex={-1} aria-labelledby="delRowLabel" aria-hidden="true">
    <div className="modal-dialog modal-sm">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="delRowLabel">
            Confirm
          </h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
          Are you sure you want to delete the Roles from list?
        </div>
        <div className="modal-footer">
          <div className="d-flex justify-content-end gap-2">
            <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
            <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" 
            onClick={() => handleDelete(delId)}>Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
 
  
  {/* Modal Edit Row */}
  <div className="modal fade" id="editRoles" tabIndex={-1} aria-labelledby="editRolesLabel" aria-hidden="true">
    <div className="modal-dialog modal-md">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="iconRowLabel">
            Edit
          </h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
        <div className="row justify-content-left">
                    <div className="col-sm-12 col-12">
                      <div className="card border mb-3">
                        <div className="card-body">
                        <div className="row gx-4">
                      <div className=" col-sm-12 col-12">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="editMod">Edit Roles <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <input type="text" id="editMod" className="form-control" value={editRoleName}  onChange={(e) => setEditRoleName(e.target.value)} />
                              <button className="btn btn-outline-secondary" type="button">
                                <i className="ri-menu-line text-black" />
                              </button>
                            </div> 
                          </div>
                       </div>
                       
                          
                          <div className=" col-sm-12 col-12">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="editDescriptionription">Description <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <textarea type="text" id="editDescriptionription" className="form-control" row="2" value={editRoleDiscription}  onChange={(e) => setEditRoleDiscription(e.target.value)} />
                              <button className="btn btn-outline-secondary" type="button">
                                <i className="ri-menu-line text-black" />
                              </button>
                            </div> 
                          </div>
                       </div>
 
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
        </div>
        <div className="modal-footer">
        <div className="d-flex justify-content-end gap-2">
            <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
            <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" onClick={handleEdit}>Edit</button>
          </div>
        </div>
             </div>
    </div>
  </div>
</div>
</div>
                </div>
              </div>
              {/* Tab content ends */}
            </div>
            {/* Custom tabs ends */}
            {/* Buttons starts */}
            
            {/* Buttons ends */}
          </div>
        </div>
      </div>
    </div>
    {/* Row ends */}
  </div>
  {/* App body ends */}
</div>
  );
}
export default CreateRoles;




